/* istanbul ignore file */
import ImageLayout from './ImageLayout';
import DocumentLayout from './DocumentLayout';
import { useUiTheme } from 'framework/uiTheme';
import { ArtifactType } from './ArtifactPreviewWrapper';

type AttachmentFieldLayoutProps = {
  value: ArtifactType;
  handleClick?: () => void;
  handleDownload?: () => void;
  handleOpenPreview?: () => void;
  getThumbnail?: (id: number | string, size: string) => Promise<Nullable<string>> | Nullable<string> | void;
  isDownloadAvailable?: boolean;
};

const AttachmentFieldLayout = ({
  value,
  handleClick = () => {},
  handleOpenPreview = () => {},
  getThumbnail = () => Promise.resolve(''),
  isDownloadAvailable = true,
  handleDownload = () => {},
}: AttachmentFieldLayoutProps) => {
  const { ArtifactImageLayout = ImageLayout, ArtifactDocumentLayout = DocumentLayout } = useUiTheme();

  return value && value.type === 'image' ? (
    <ArtifactImageLayout
      value={value}
      getThumbnail={getThumbnail}
      handleDownload={handleDownload}
      handleClick={handleClick}
    />
  ) : (
    <ArtifactDocumentLayout
      value={value}
      handleDownload={handleClick}
      handleOpenPreview={handleOpenPreview}
      isDownloadAvailable={isDownloadAvailable}
    />
  );
};

export default AttachmentFieldLayout;
